import Page from 'src/components/page/page';
import useCollectionsDetails from './collections-details.hook';
import { Box, Container, Stack } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import CNLoading from 'src/components/loading-cn/CNLoading';
import CollectionForm from './components/collection-form';
import CollectiblesListByCollection from './components/colletibles-list-by-colletion';
import { paths } from 'src/routes/paths';
import { Icon } from '@iconify/react';
import RegisterCpfs from './components/cpf-modal';

export default function CollectionsDetails() {
  const {
    isEdit,
    isLoadingCollectionDetails,
    isLoadingCollectionPeriods,
    methods,
    isSubmitting,
    STATUS_LABEL,
    STATUS_OPTIONS,
    PRIVATE_LABEL,
    PRIVATE_OPTIONS,
    values,
    control,
    isValidEndDate,
    hasUnavailableCollectionDateRangeOverlap,
    shouldDisableCollectionDate,
    id,
    isLoadingCollectibles,
    updatingCollectibleTypeId,
    collectiblesList,
    activeFreeCollectiblesCount,
    DONT_LABEL,
    DONT_OPTIONS,
    cpfs,
    openCpfs,
    isPrivate,
    fileNameCpfs,
    hasCpfsToDownload,
    handleDownloadCpfs,
    onSubmit,
    handleDrop,
    handleToggleCollectibleType,
    navigate,
    setOpenCpfs,
    onCloseCpfs,
    handleUploadCpfs,
  } = useCollectionsDetails();

  return (
    <Page title={isEdit ? 'Editar Coleção' : 'Cadastrar Coleção'}>
      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          heading={
            <Stack direction="row" alignItems="center" spacing={1}>
              <Icon
                icon="weui:back-filled"
                width="18"
                height="22"
                style={{ cursor: 'pointer' }}
                onClick={() => navigate(paths.dashboard.collectionsList)}
              />
              <span>{isEdit ? 'Editar Coleção' : 'Cadastrar Coleção'}</span>
            </Stack>
          }
          links={[]}
        />
        {isLoadingCollectionDetails ? (
          <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" mt={30}>
            <CNLoading />
          </Box>
        ) : (
          <Stack spacing={2}>
            <CollectionForm
              methods={methods}
              onSubmit={onSubmit}
              isEdit={isEdit}
              isSubmitting={isSubmitting}
              statusOptions={STATUS_OPTIONS}
              statusLabel={STATUS_LABEL}
              privateOptions={PRIVATE_OPTIONS}
              privateLabel={PRIVATE_LABEL}
              values={values}
              control={control}
              isValidEndDate={isValidEndDate}
              isPrivate={isPrivate}
              handleDrop={handleDrop}
              dontLabel={DONT_LABEL}
              dontOptions={DONT_OPTIONS}
              cpfs={cpfs}
              setOpenCpfs={setOpenCpfs}
              handleDownloadCpfs={handleDownloadCpfs}
              hasCpfsToDownload={hasCpfsToDownload}
              activeFreeCollectiblesCount={activeFreeCollectiblesCount}
              isLoadingCollectionPeriods={isLoadingCollectionPeriods}
              hasUnavailableCollectionDateRangeOverlap={hasUnavailableCollectionDateRangeOverlap}
              shouldDisableCollectionDate={shouldDisableCollectionDate}
            />

            {isEdit && (
              <Stack spacing={2}>
                <CollectiblesListByCollection
                  isLoadingCollectibles={isLoadingCollectibles}
                  collectiblesList={collectiblesList}
                  collectionId={id}
                  updatingCollectibleTypeId={updatingCollectibleTypeId}
                  onToggleCollectibleType={handleToggleCollectibleType}
                />
              </Stack>
            )}

            <RegisterCpfs
              openCpfs={openCpfs}
              onCloseCpfs={onCloseCpfs}
              handleUploadCpfs={handleUploadCpfs}
              fileNameCpfs={fileNameCpfs}
            />
          </Stack>
        )}
      </Container>
    </Page>
  );
}
